import React, { useEffect, useRef, useState } from 'react';

export const AboutUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="home-section home-section-dark about-blend-section" ref={sectionRef}>
      <div className="home-section-inner">
        <div className="home-section-header">
          <h2 className="section-title-inline title-light-text">
            <span className="title-light">ABOUT</span> <span className="title-bold">US.</span>
          </h2>
        </div>
        <div className={`about-content-block ${isVisible ? 'content-visible' : ''}`}>
          <p className="about-text-large">
            Domus Living is a Melbourne-based architectural design studio specialising in residential architecture. 
            We are a small, client-focused practice that believes great homes come from listening, collaboration, 
            and thoughtful design.
          </p>
          <p className="about-text-large">
            Our work blends timeless architectural principles with contemporary living, resulting in homes that 
            feel balanced, personal, and enduring. From early ideas to the final built outcome, we work closely 
            with our clients to shape homes that feel considered, authentic, and deeply connected to the way they live.
          </p>
        </div>
      </div>
    </section>
  );
};
